import {api} from '_api';
import type {LoggedIn} from "_types/responses/auth";
import type {Finder, Mutator} from '_types/swr';
import type {NoContent} from "_types/aspnet";
import type {TwoFactorCode} from "_types/requests/two-factor";

import {unwrap} from '_utils/axios';
import {parseKey} from '_utils/swr';
import {TwoFactorGenerated} from "_types/responses/two-factor";


export const enableTwoFactor: Mutator<NoContent, TwoFactorCode> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);

    return await unwrap(response);
};

export const validateTwoFactor: Mutator<LoggedIn, TwoFactorCode> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);

    return await unwrap(response);
};

export const disableTwoFactor: Mutator<NoContent> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.delete<NoContent>(url);

    return await unwrap(response);
};


export const getTwoFactor: Finder<TwoFactorGenerated> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<TwoFactorGenerated>(url);

    return await unwrap(response);
};
